module.exports = __webpack_public_path__ + "static/media/Crying.45aef624.jpg";